import React from 'react';
import { Hero } from '../components/Hero';
export function Landing() {
  return <div className="min-h-screen bg-white text-bg-primary font-sans selection:bg-accent selection:text-bg-primary" data-id="element-50">
      <Hero data-id="element-51" />
    </div>;
}